import React, { useCallback, useEffect } from 'react';
import { ShoppingCart } from '@hpi-sox/hpstellar-veneer-icons';

import ButtonIcon from './button-icon';
import CartPreview from '../../../utility/components/cart-preview/cart-preview';
import { useHeaderSettings } from '../../../hooks/useHeaderFooter';
import { RenderOnMount } from '../../../shared/components/above-the-fold-only-server-render';
import { useTemplateKey } from '../../../hooks/usePageComponents';

import './header-cart.less';

const DigitNAVCloseCart = ({ close }) => {
    useEffect(() => {
        const digitNavHeader = document.querySelector('digitnav-header');
        if (close && digitNavHeader) {
            //if some clicks on digitnav-header close the cart
            if (digitNavHeader) {
                document.querySelector('.action-buttons .sign-in-button').addEventListener('mouseenter', close);
            }
        }
        return () => {
            if (digitNavHeader) {
                document.querySelector('.action-buttons .sign-in-button').removeEventListener('mouseenter', close);
            }
        };
    }, [close]);
};

/** Presentational compotent shared by desktop and mobile headers */
export function HeaderCart({ localState, enableCartFlyout, enableHeaderState = true, variation, className }) {
    const templateKey = useTemplateKey();
    const headerSettings = useHeaderSettings();
    const { disableCart } = headerSettings;
    const hoverCallback =
        variation === 'digit'
            ? useCallback(() => {
                  try {
                      document.querySelector('digitnav-header').signinInstance.hide();
                  } catch (e) {}
              })
            : undefined;
    if ((enableHeaderState && disableCart) || ['cart', 'checkout'].includes(templateKey)) {
        return null;
    }
    const ButtonComponent = variation === 'digit' ? 'button' : ButtonIcon;

    return (
        <div className={`header-cart${className ? ` ${className}` : ''}`}>
            <CartPreview
                stickyCart
                localState={localState}
                enableCartFlyout={enableCartFlyout}
                onHover={hoverCallback}
                variation={variation}
            >
                {({ count, onHover, onMouseLeave, onFocus, onClick, isNewVersion, showPreview, close }) => {
                    const buttonClass = `header-cart-button${isNewVersion ? ' new-version' : ''}${
                        showPreview ? ' minicart-open' : ''
                    }`;
                    const buttonProps = {
                        onClick,
                        onMouseEnter: onHover,
                        icon: 'icon-cart',
                        onMouseLeave,
                        onFocus: onFocus,
                        tabIndex: 0,
                        ...(variation === 'digit'
                            ? { className: buttonClass, 'aria-label': 'Shopping Cart' }
                            : { buttonClass, ariaLabel: 'Shopping Cart' }),
                    };
                    return (
                        <ButtonComponent {...buttonProps}>
                            {variation === 'digit' && <ShoppingCart size={24} />}
                            {variation === 'digit' && <DigitNAVCloseCart close={close} />}
                            <RenderOnMount>
                                {count && (
                                    <span className="cart-badge-container">
                                        <span className="cart-badge">{count}</span>
                                    </span>
                                )}
                            </RenderOnMount>
                        </ButtonComponent>
                    );
                }}
            </CartPreview>
        </div>
    );
}
export default HeaderCart;
